export type FrameDevice = 'desktop' | 'mobile';

/** D-P0-9: the real desktop breakpoint of the storefront, and one phone. */
export const DESKTOP_FRAME_WIDTH = 1280;
export const MOBILE_FRAME_WIDTH = 390;
/** Below this scale the frame scrolls sideways instead of shrinking further. */
export const MIN_DESKTOP_FRAME_SCALE = 0.55;

export interface FrameViewport {
  /** CSS px width of the storefront document. Its media queries see this number. */
  readonly width: number;
  /** 1 means unscaled. Only the desktop frame is ever scaled down. */
  readonly scale: number;
  /** Width the wrapper takes up in the Admin layout (`width * scale`). */
  readonly outerWidth: number;
}

/**
 * The size of the storefront frame in an Admin column `available` px wide.
 *
 * Desktop renders the storefront at 1280 CSS px and scales that down with a
 * transform when the column is narrower, to `MIN_DESKTOP_FRAME_SCALE` at the
 * least (then the column scrolls). Mobile is 390 px, never scaled. The two
 * use the same iframe element; only this wrapper changes.
 */
export function computeFrameViewport(device: FrameDevice, available: number): FrameViewport {
  if (device === 'mobile') {
    return { width: MOBILE_FRAME_WIDTH, scale: 1, outerWidth: MOBILE_FRAME_WIDTH };
  }
  const usable = Number.isFinite(available) && available > 0 ? available : DESKTOP_FRAME_WIDTH;
  const scale = Math.min(1, Math.max(MIN_DESKTOP_FRAME_SCALE, usable / DESKTOP_FRAME_WIDTH));
  return {
    width: DESKTOP_FRAME_WIDTH,
    scale,
    outerWidth: Math.round(DESKTOP_FRAME_WIDTH * scale),
  };
}
